module.exports = __webpack_public_path__ + "static/media/16.7e43d4a1.gif";